import { IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, IsUUID, Min } from 'class-validator';
import {
  MICRONUTRIENT_CODES,
  type MicronutrientCode,
} from '../../nutrition/micronutrient-registry';
import {
  MICRONUTRIENT_SOURCE_TYPES,
  type MicronutrientSourceType,
} from './micronutrient-source-type.enum';

/**
 * One persisted micronutrient row of a nutritional profile version. Append-only
 * like its parent profile: `id` never changes after insert, there is no update
 * path for this DTO.
 */
export class MicronutrientResponseDto {
  @IsUUID()
  id!: string;

  @IsEnum(MICRONUTRIENT_CODES)
  nutrientCode!: MicronutrientCode;

  @IsNumber()
  @Min(0)
  amountPer100g!: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  declaredEndOfShelfLifePer100g?: number | null;

  @IsEnum(MICRONUTRIENT_SOURCE_TYPES)
  sourceType!: MicronutrientSourceType;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  sourceReference?: string | null;
}
